export default [
	{
		path: '/admin/repair-products',
		name: 'repair-product',
		meta: { requiresAuth: true },
		component: () => import('@/pages/customer-service/repair-product/index.vue')
	}
]